import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-somos',
    templateUrl: './somos.component.html',
    styleUrls: ['./somos.component.less'],
    standalone: false
})
export class SomosComponent implements OnInit {

  constructor() { }
  age: number = 0;
  ngOnInit() {
    this.age = new Date().getFullYear() - 1936;
  }

}
